import React from "react";

const RecordsByDepartment = ({ resPacket }) => {
    return resPacket?.length > 0 ? (
        <table className="customTable">
            <thead>
                <tr>
                    <td>ISSUANCE DATE</td>
                    <td>DEPARTMENT</td>
                    <td>ISSUED BY</td>
                    <td>ISSUED TO</td>
                </tr>
            </thead>

            <tbody>
                {resPacket.map((a, i) => (
                    <tr key={i}>
                        <td>{a.issuanceDate}</td>
                        <td>{a.issuedDepartmentTitle}</td>
                        <td>{a.issuedByUserTitle}</td>
                        <td>{a.issuedToUserTitle}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    ) : (
        <>No Record found</>
    );
};

export default RecordsByDepartment;
